import { Clock, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface AnalysisPendingProps {
  matchDate?: string; // ISO date string
}

export function AnalysisPending({ matchDate }: AnalysisPendingProps) {
  const { t } = useTranslation('analysis');

  const getTimeMessage = () => {
    if (!matchDate) return t('messages.availableCloseToKickoff');
    
    const kickoff = new Date(matchDate);
    const now = new Date();
    const hoursUntilKickoff = (kickoff.getTime() - now.getTime()) / (1000 * 60 * 60);
    
    if (hoursUntilKickoff > 48) {
      return t('messages.generatedBefore36h');
    } else if (hoursUntilKickoff > 36) {
      return t('messages.availableSoon');
    } else if (hoursUntilKickoff > 0) {
      return t('messages.beingPrepared');
    } else {
      return t('messages.notAvailable');
    }
  };

  return (
    <Card className="bg-muted/30 border-dashed sketch-border">
      <CardContent className="flex flex-col items-center justify-center py-12 text-center">
        <div className="rounded-full bg-primary/10 p-4 mb-4">
          <Sparkles className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-lg font-bold mb-2">
          {t('status.inPreparation')}
        </h3>
        <p className="text-muted-foreground text-sm max-w-sm">
          {getTimeMessage()}
        </p>
        <div className="flex items-center gap-2 mt-4 text-xs text-muted-foreground">
          <Clock className="h-3 w-3" />
          <span>{t('status.generatedAutomatically')}</span>
        </div>
      </CardContent>
    </Card>
  );
}
